import React, { Component } from 'react';
import './sr-only.css';
import PropTypes from 'prop-types';
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { TextInput } from 'grommet/components/TextInput';
import { Button } from 'grommet/components/Button';
import AccessibleSelect from '../Components/AccessibleSelect';
import ReactTable from "react-table";
//import { Document, Page, PDFDownloadLink } from 'react-pdf';
/*import data from '../Data.json';*/
import { SearchAccountBalanceCtrl } from '../Controllers/Balance/SearchAccountBalanceCtrl';
import { GetPDFAccountBalanceCtrl } from '../Controllers/Balance/GetPDFAccountBalanceCtrl';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { loader, noData } from '../Utils/Utility';


class EstrattoConto extends Component {
    static propTypes = {
        match: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    }
    constructor(props) {
        super(props);
        this.state = {
            dataTable: [],
            dataPdf: [],
            search: '',
            status:'',
            codesoc: sessionStorage.getItem('codesoc') !== '' ? sessionStorage.getItem('codesoc') : "",//"9285568127",
            codepos: sessionStorage.getItem('codepos') !== '' ? sessionStorage.getItem('codepos') : "", //"9522832757",
            value: [],
            months: [],
            selectedMonthYearLabel: '',
            selectedMonthYear: '',
            numericMonths: '',
            monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
            showTimeoutModal: false,
            isRicerca: false,
            pages: 0,
            currentPage: 1
        }
        this.setSearch = this.setSearch.bind(this);
        this.setSelectionMonthYear = this.setSelectionMonthYear.bind(this);
        this.setDates = this.setDates.bind(this);
        this.showResult = this.showResult.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.goToPage = this.goToPage.bind(this);
        this.search = this.search.bind(this);

    }

    componentDidMount() {
        var token = sessionStorage.getItem('token');
        var ids = sessionStorage.getItem('ids');

        const self = this;
        this.setDates();

        this.setState({
            isRicerca: true
        },()=>{
            SearchAccountBalanceCtrl(function (data) {
                self.setState({
                    dataTable: data === '' ? [] : data.accountListItems,
                    pages: Math.ceil(data.totalElements / 60),
                    isRicerca: false
                });
            }, function (error) {
                self.setState({
                    status: error
                }, function(){
                    if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                        this.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })  
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                    } 
                })

            }, this.state, token, ids);
        });
    }

    setSelectionMonthYear(event) {
        // Estrae il valore dall'oggetto dell'opzione selezionata
        const selectedValue = event.option ? event.option.value : '';
        const selectedIndex = this.state.months.findIndex(month => month === selectedValue);
        var val = selectedIndex >= 0 ? this.state.numericMonths[selectedIndex] : '';
        
        this.setState({
            selectedMonthYearLabel: selectedValue,
            selectedMonthYear: val
        })
    }


    setDates() {
        var date = new Date();
        var months = []
        var numericMonths = [],
            monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

        for (var i = 0; i < 13; i++) {
            var calMonth = 1 + date.getMonth()
            var tempMonth = calMonth < 10 ? '0' + calMonth : calMonth


            months.push(monthNames[date.getMonth()] + ' ' + date.getFullYear());
            
            numericMonths.push(date.getFullYear() + '' + tempMonth);
            date.setMonth(date.getMonth() - 1);
            

        }
        return this.setState({ months, numericMonths })
    }

    setPoint(i) {

        const newSelected = this.state.selected;
        const newValue = this.state.value;
        newSelected[i] = !this.state.selected[i];
        newValue[i] = [i];

        this.setState({
            selected: newSelected,
            value: newValue
        })

    }

    setSearch(event) {
        this.setState({
            search: event.target.value
        })
    }



    showResult() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        this.setState({
            isRicerca: true
        }, () => {
            SearchAccountBalanceCtrl(function (data) {
                self.setState({
                    dataTable: data === '' ? [] : data.accountListItems,
                    pages: Math.ceil(data.totalElements / 60),
                    isRicerca: false
                });
            }, function (error) {
                self.setState({
                    status: error
                }, function(){
                    if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                        this.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })  
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                    } 
                })
    
            }, this.state, token, ids);
        })
        
    }

    downloadPDF(branchCode, date) {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;

        GetPDFAccountBalanceCtrl(function (data) {
            self.setState({
                dataPdf: data === '' ? [] : data
            });
            const file = new Blob([data], {type: 'application/pdf'});
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file, "estrattoconto.pdf");
            } else {
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }
        }, function (error) {
            self.setState({
                status: error
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })  
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                } 
            })

        }, branchCode, date, token, ids);
    }


    search(){
        this.setState({
            currentPage: 1,
            pages: 0,
            dataTable: []
        }, () => {
            this.showResult();
        });
    }

    prevPage(){
        let cp = this.state.currentPage;
        if (cp === 1) return;
        this.setState({
          currentPage: cp - 1
        },() => {
          this.showResult();
        });
    }
    
    nextPage(){
        let cp = this.state.currentPage;
        if (cp === this.state.pages) return;
        this.setState({
            currentPage: cp + 1
        },() => {
            this.showResult();
        });
    }

    goToPage(page) {
        if(page === this.state.currentPage) return;
        this.setState({
            currentPage: page
        },() => {
            this.showResult();
        });
    }



    render() {

        const columns = [

            {
                Header: 'DATA',
                accessor: 'date',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'CODICE ESERCIZIO',
                id: 'branchCode',
                accessor: a => (a.branchCode ? a.branchCode : "Tutti"),
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'INSEGNA',
                id: 'name',
                accessor: a => (a.name ? a.name : "Tutte"),
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'APRI E SCARICA IL PDF',
                Cell: (props) => (
  <button
    onClick={() => this.downloadPDF(props.row.branchCode, props.row.date)}
    aria-label="Scarica PDF"
    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
  >
    <i className="icon-note download" aria-hidden="true" aria-label="Scarica PDF" style={{ fontSize: '24px' }}></i>
    <span className="sr-only">Scarica PDF</span>
  </button>
),
                headerClassName: 'sH',
            }

        ]
                       
        const hasData = (Array.isArray(this.state.dataTable) && this.state.dataTable.length > 0 && this.state.dataTable !== null && this.state.dataTable !== undefined)
        
        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}

                <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>

                    <Box className='contentbox'>

                            <Box align='center' id='searchpv' justify='center'>
                                <Box className='genericext' direction='row' gap='medium'>
                                    {this.state.codepos === '' ?
                                        <Box>
                                            <Text className='label' id='store-search-label' htmlFor='store_search' style={{marginBottom:'1px'}}>RICERCA PER PUNTO VENDITA</Text>
                                            <TextInput 
                                                id="store_search" 
                                                className='inputSearchpv inputEstratto' 
                                                maxLength={40} 
                                                value={this.state.search} 
                                                placeholder='' 
                                                onChange={this.setSearch} 
                                                aria-labelledby='store-search-label'
                                                aria-required='false'
                                                onKeyDown={(event) => {
                                                    if (event.key === 'Enter') {
                                                        this.search();
                                                    }
                                                }}
                                            />
                                            <Text className='suggestion' id='store-search-hint'>(Inserisci codice/insegna esercizio o parziale)</Text>
                                        </Box>
                                        :
                                        null
                                    }
                                    <Box>
                                         <Text className='label' id='month-select-label' htmlFor='monthEC' aria-hidden="false"><h5>SCEGLI IL MESE</h5></Text>
                                        <AccessibleSelect
                                            id='monthEC'
                                            className='select'
                                            placeholder='Tutti'
                                            options={this.state.months.map(month => ({
                                                label: month,
                                                value: month,
                                                'aria-label': month
                                            }))}
                                            labelKey='label'
                                            valueKey='value'
                                            value={this.state.selectedMonthYearLabel ? {
                                                label: this.state.selectedMonthYearLabel,
                                                value: this.state.selectedMonthYearLabel,
                                                'aria-label': this.state.selectedMonthYearLabel
                                            } : ''}
                                            onChange={this.setSelectionMonthYear}
                                            aria-labelledby='month-select-label'
                                            a11yTitle='Scegli il mese'
                                            dropAlign={{ top: 'bottom' }}
                                            dropProps={{
                                                a11yTitle: 'Opzioni di mese disponibili',
                                                role: 'listbox',
                                                'aria-multiselectable': 'false'
                                            }}
                                            messages={{
                                                multiple: 'Selezionato',
                                                selected: 'Selezionato'
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Box>

                            {/* Pulsante Cerca spostato sotto per migliore visibilità */}
                            <Box align='center' style={{ marginTop: '20px' }}>
                                <Button 
                                    className='btnsearch btnEstratto' 
                                    onClick={this.search} 
                                    aria-label='Ricerca estratto conto'
                                    role='button'
                                >
                                    <span>CERCA</span>
                                    <i className='icon-magnifying-glass' style={{ fontSize: '22px', marginLeft: '5px' }} aria-hidden="true"></i>
                                </Button>
                            </Box>

                            <Box direction='row'>
                                <Box pad='large' className='table' role='region' aria-label='Risultati estratto conto'>

                                    {hasData ? 
                                        [<ReactTable
                                            data={this.state.dataTable}
                                            columns={columns}
                                            sortable={true}
                                            multiSort={false}
                                            resizable={true}
                                            showPagination={false}
                                            defaultPageSize={this.state.dataTable.length}
                                            style={{ paddingBottom: '20px' }} />,
                                            <div>
                                                <div style={{ height: '50px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <button
                                                        type="button"
                                                        style={{ width: '20px', height: '30px', color: '#006fcf', cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}
                                                        onClick={() => { this.goToPage(1); }}
                                                        aria-label="Prima pagina"
                                                        disabled={this.state.currentPage === 1}
                                                    >
                                                        <i className='icon-double-left' style={{ fontSize: '24px', fontStyle: 'normal' }} aria-hidden="true"></i>
                                                        <span className="sr-only">Prima pagina</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        style={{ width: '20px', height: '30px', color: '#006fcf', cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}
                                                        onClick={() => { this.prevPage(); }}
                                                        aria-label="Pagina precedente"
                                                        disabled={this.state.currentPage === 1}
                                                    >
                                                        <i className='icon-left-chevron' style={{ fontSize: '24px', fontStyle: 'normal' }} aria-hidden="true"></i>
                                                        <span className="sr-only">Pagina precedente</span>
                                                    </button>

                                                    <Text className='pag' style={{ fontSize: '12px', marginBottom: '12px' }} aria-live='polite' role='status' aria-label={`Pagina ${this.state.currentPage} di ${this.state.pages}`}>{this.state.currentPage} di {this.state.pages}</Text>

                                                    <button
                                                        type="button"
                                                        style={{ width: '20px', color: '#006fcf', cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}
                                                        onClick={() => { this.nextPage(); }}
                                                        aria-label="Pagina successiva"
                                                        disabled={this.state.currentPage === this.state.pages}
                                                    >
                                                        <i className='icon-right-chevron' style={{ fontSize: '24px', fontStyle: 'normal' }} aria-hidden="true"></i>
                                                        <span className="sr-only">Pagina successiva</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        style={{ width: '20px', color: '#006fcf', cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}
                                                        onClick={() => { this.goToPage(this.state.pages); }}
                                                        aria-label="Ultima pagina"
                                                        disabled={this.state.currentPage === this.state.pages}
                                                    >
                                                        <i className='icon-double-right' style={{ fontSize: '24px', fontStyle: 'normal' }} aria-hidden="true"></i>
                                                        <span className="sr-only">Ultima pagina</span>
                                                    </button>
                                                </div>
                                            </div>]

                                        : this.state.isRicerca ?
                                            loader

                                        : noData
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
        )
    }
}
export default EstrattoConto;